import { observable, toJS } from "mobx";
import DataStore from "../../../stores/DataStore";
import * as moment from "moment";
import ServicosService from "../services/ServicosService";
import { E_PARCIAL_TOTAL_IMP, E_STATUS_CNTR, E_TIPO_CLIENTE, E_TIPO_CNTR, E_TIPO_REGIME, E_TITULO_TELA, E_TIPO, E_TIPO_DECLARACAO } from "./Enum";
import { E_CG_REF_CODES, E_CONDICAO } from './Enum';
import { terminal as TERMINAL } from "../../../config/Constantes";
import cabecalhoRIG from '../../../assets/images/pdf_cabecalho_rig.png'
import cabecalhoSSA from '../../../assets/images/pdf_cabecalho_ssa.png'
import { convertKeyValueToNumber, getBase64ImageFromURL } from "../../../utils/functions";
import SimulacaoServicosCalcStore from "./SimulacaoServicosCalcStore";
import { AvisoImportante } from "./SimulacaoServicosStore";

const importacaoLayout = {
    DataEntrada: moment().format("YYYY-MM-DD"),
    DataSaida: moment().add(1, 'days').format("YYYY-MM-DD"),
    TipoRegime: null,
    ManualMecanizada: null,
    ParcialTotal: null,
    TipoDeclaracao: null,
    Servicos: [],
    Bls: [],
    Erros: {},
};

const blLayout = {
    NumBl: 0,
    ValorCif: null,
    Items: [],
    Erros: {}
};

const itemBlLayout = {
    QtdContainer: 1,
    Cntr: 1,
    Tipo: null,
    Status: null,
    TipoCntr: null,
    Refrigerada: false,
    Especial: false,
    Imo: false,
    Vistoria: false,
    PesoDocumental: null, 
    MetragemDocumental: null,
    Erros: {}
};

const dadosLabelsImp = {
    DtCriacao: "Data Simulação",
    DataEntrada: "Data Entrada",
    DataSaida: "Data Saída",
    TipoRegime: "Tipo de Regime",
    ManualMecanizada: "Modo Carregamento",
    TipoDeclaracao: "Tipo de Declaração",
    QtdIsoCntr: "Tipo",
    QtdStatus: "Status do Container",
    QtdTipoCntr: "Tipo de Container",
    QtdCntr: "Qtd. Container",
    QtdEspecial: "Qtd. Especial",
    QtdImo: "Qtd. Imo",
    // RazaoSocial: "Razão Social",
    // CnpjTecon: "CNPJ Tecon",
};

const dadosLabelsBlImp = {
    NumBl: "BL Nº",
    QtdCntr: "Qtd. Container",
    QtdEspecial: "Qtd. Especial",
    QtdImo: "Qtd. Imo",
    QtdTipoCntr: "Tipo de Container",
    QtdIsoCntr: "Tipo",
    ValorCif: "Valor CIF",
    SomaTonelagem: 'Tonelagem (Kg)',
    SomaCubagem: 'Volume Cúbico (m³)',
};

export default class SimulacaoServicosImpStore extends DataStore {

    // Geral
    @observable servicos = [];
    @observable loadingServicos = false;
    
    temArmador;

    data = this.defaultObj(importacaoLayout);
    opcoesStatusContainer = this.defaultObj([]);
    opcoesTipoDeclaracaoImp = this.defaultObj([]);
    opcoesTipoRegimeImp = this.defaultObj([]);
    opcoesManualMecanizadaImp = this.defaultObj([]);
    opcoesParcialTotalImp = this.defaultObj([]);
    opcoesTiposContainer = this.defaultObj([]);
    opcoesTipoCntr = this.defaultObj([]);

    @observable tipoCliente;

    constructor() {
        super();

        this.calcStore = new SimulacaoServicosCalcStore();
    };

    get servicosAgrupados() {
        return this.calcStore.agrupaServicos(this.servicos);
    }

    async fecthOptions(tipoCliente) {
        this.setTipoCliente(tipoCliente);
        try {
            await Promise.all([
                this.fetchAndSetData(this.opcoesTiposContainer, ServicosService.listarOpcoesServicosPorTipo, E_CG_REF_CODES.IsoCntr),
                this.fetchAndSetData(this.opcoesStatusContainer, ServicosService.listarOpcoesServicosPorTipo, E_CG_REF_CODES.StatusCntr),
                this.fetchAndSetData(this.opcoesTipoRegimeImp, ServicosService.listarOpcoesServicosPorTipo, E_CG_REF_CODES.TipoRegime),
                this.fetchAndSetData(this.opcoesTipoDeclaracaoImp, ServicosService.listarOpcoesServicosPorTipo, E_CG_REF_CODES.TipoDeclaracao),
                this.fetchAndSetData(this.opcoesManualMecanizadaImp, ServicosService.listarOpcoesServicosPorTipo, E_CG_REF_CODES.ManualMecanizada),
                this.fetchAndSetData(this.opcoesParcialTotalImp, ServicosService.listarOpcoesServicosPorTipo, E_CG_REF_CODES.ParcialTotal),
                this.fetchAndSetData(this.opcoesTipoCntr, ServicosService.listarOpcoesServicosPorTipo, E_CG_REF_CODES.TipoCntr),
            ]);
        } catch (error) {
            console.error(error);
        }
    }

    setTipoCliente(tipoCliente) {
        this.tipoCliente = tipoCliente;
    }

    opcoesTipoCntrFiltradasPorIndex(blIndex, index) {
        let options = toJS(this.opcoesTipoCntr.value);

        const container = toJS(this.data.value.Bls).at(blIndex).Items.at(index);

        const filtraBundle = (container.Status && container.Status.value == E_STATUS_CNTR.Cheio) || !this.temArmador;
        const filtraOog = TERMINAL == 'SSA' && !this.temArmador;

        if (filtraBundle) options = options.filter(opt => opt.value != E_TIPO_CNTR.Bundle);
        if (filtraOog) options = options.filter(opt => opt.value != E_TIPO_CNTR.OOG);

        return options;
    }

    get opcoesTipoDeclaracaoFiltradas() {
        if (this.showOptionPier)
            return toJS(this.opcoesTipoDeclaracaoImp.value).filter(opt => opt.value != E_TIPO_DECLARACAO.CRP && opt.value != E_TIPO_DECLARACAO.DTC);
        else
            return toJS(this.opcoesTipoDeclaracaoImp.value);
    }

    disableEspecialOption(blIndex, index) {
        const { TipoCntr, Status } = toJS(this.data.value.Bls).at(blIndex).Items.at(index);

        const isNotDryOrTank = TipoCntr && (TipoCntr.value != E_TIPO_CNTR.Dry && TipoCntr.value != E_TIPO_CNTR.Tank)

        const isTankAndEmpty = TipoCntr && Status && (TipoCntr.value == E_TIPO_CNTR.Tank && Status.value == E_STATUS_CNTR.Vazio)

        return isNotDryOrTank || isTankAndEmpty;
    }

    clearFields = () => {
        this.resetarServicos();
        this.data = this.defaultObj(importacaoLayout);
    }

    setItem = (key, newValue) => {
        this.setValue(this.data, {...this.data.value, [key]: newValue, ['Erros']: {...this.data.value.Erros, [key]: null} } );

        if (key == 'TipoRegime') {
             let optParcialTotal = null;
            
            if (!newValue || newValue == E_TIPO_REGIME.House) {
                this.setValue(this.data, {...this.data.value, ['ManualMecanizada']: null } );          
            }
            
            if (newValue && newValue == E_TIPO_REGIME.Pier) {                    
                optParcialTotal = toJS(this.opcoesParcialTotalImp.value).find(({value}) => value == E_PARCIAL_TOTAL_IMP.Total);
            }

            this.setValue(this.data, {...this.data.value, ['ParcialTotal']: optParcialTotal ? optParcialTotal.value : null} );
        }

        if (this.canAddNewBls && this.data.value.Bls.length == 0) this.addBl();
    }

    setDefaultValuesByTipoCliente(tipoCliente) {     
        this.temArmador = tipoCliente == E_TIPO_CLIENTE.Armador;

        if (this.canAddNewBls && this.data.value.Bls.length == 0) this.addBl();
    }

    get showOptionPier() {
        const { TipoRegime } = toJS(this.data.value);
        return TipoRegime ? TipoRegime == E_TIPO_REGIME.Pier : false;
    }

    get showOptionHouse() {
        if (this.temArmador) return true;
        const { TipoRegime } = toJS(this.data.value);
        return TipoRegime ? TipoRegime == E_TIPO_REGIME.House : false;
    }

    addBl = () => {
        const lastIndex = this.data.value.Bls.length;

        const newBl = {...blLayout, NumBl: lastIndex + 1, Items: [ itemBlLayout ]}

        this.data.value.Bls = [ ...this.data.value.Bls, newBl ];
    }

    setBl = (index, key, newValue) => {
        const item = this.data.value.Bls.at(index);
        item[key] = newValue;

        item.Erros[key] = null;
        item.Erros['Item'] = null;
    }

    resetBls = () => {
        this.data.value.Bls = [];
    }

    removeBl = (blIndex) => {
        this.data.value.Bls = this.data.value.Bls.filter((_, i) => i != blIndex).map((bl, index) => ({ ...bl, NumBl: index + 1 }));
    }

    get hasBls() {
        return this.data.value.Bls.length > 0;
    }

    get canAddNewBls() {
        const { TipoRegime, TipoDeclaracao, ManualMecanizada, ParcialTotal } = this.data.value;
        const showOptionPier = TipoRegime ? TipoRegime == E_TIPO_REGIME.Pier : false;

        const declaracaoOk = !this.temArmador ? TipoDeclaracao && TipoRegime : true;
        const pierOptionsOk = (showOptionPier ? ManualMecanizada && ParcialTotal : true);

        const canAdd = (declaracaoOk && pierOptionsOk);

        return canAdd;
    }

    addItemBl = (blIndex) => {
        const bl = this.data.value.Bls.at(blIndex);
        const lastIndex = bl.Items.length;
        bl.Items = [ ...bl.Items, { ...itemBlLayout, Cntr: lastIndex + 1 } ];
    }

    removeItemBl = (blIndex, itemIndex) => {
        const bl = this.data.value.Bls.at(blIndex);

        bl.Items = bl.Items.filter((_, i) => i != itemIndex);
    }

    setItemBl = (key, newValue, blIndex, itemIndex) => {
        const bl = this.data.value.Bls.at(blIndex);

        const item = bl.Items.at(itemIndex);

        item[key] = newValue;

        if (key == 'TipoCntr') {
            item.Refrigerada = newValue.value == E_TIPO_CNTR.Reefer;
            item.Especial = TERMINAL == "SSA" && newValue.value == E_TIPO_CNTR.FlatOpenTop;
        }

        if (key == 'Status') {
            if (item.TipoCntr && item.TipoCntr.value == E_TIPO_CNTR.Bundle && newValue.value == E_STATUS_CNTR.Cheio) 
                item.TipoCntr = null;
            if (item.TipoCntr && item.TipoCntr.value == E_TIPO_CNTR.Tank && newValue.value == E_STATUS_CNTR.Vazio) 
                item.Especial = false;
        }

        item.Erros[key] = null;
        item.Erros['Item'] = null;
    }

    /**
     * Validade and set errors 
     */
    gerarServicos = async(filtros) => {
        const { DataEntrada, DataSaida, TipoRegime, ManualMecanizada, ParcialTotal, TipoDeclaracao, Bls, Erros } = toJS(this.data.value);

        // validação de campos não preenchidos
        let validacao = 0;
        let validacaoDatas = 0;

        if (!DataEntrada) {
            this.setValue(this.data, {...this.data.value, ['Erros']: {...this.data.value.Erros, ['DataEntrada']: 'Obrigatório!'}  } );
            validacao++;
        }

        if (!DataSaida) {
            this.setValue(this.data, {...this.data.value, ['Erros']: {...this.data.value.Erros, ['DataSaida']: 'Obrigatório!'}  } );
            validacao++;
        }

        if (moment(DataEntrada).isAfter(DataSaida)) validacaoDatas++;

        if (Array.from(Bls).length == 0) {
            this.setError(this.data, 'Nenhum item adicionado');
            return { error: true };;
        }

        const blMapped = Bls.map(bl => {
            const { ValorCif, Items } = bl;
            if(!this.temArmador && !(ValorCif)) {
                validacao++;
                if(!ValorCif) bl.Erros['ValorCif'] = 'Obrigatório!';
            }

            bl.Items = Items.map(item => {
                const { QtdContainer, Tipo, TipoCntr, MetragemDocumental, PesoDocumental, Refrigerada, Especial, Imo, Vistoria } = item;

                if (!this.temArmador) item.Status = this.opcoesStatusContainer.value.find(o => o.value == E_STATUS_CNTR.Cheio);

                if(!MetragemDocumental && TipoRegime == E_TIPO_REGIME.Pier && TERMINAL == 'RIG') {
                    validacao++;
                    item.Erros['MetragemDocumental'] = 'Obrigatório!';
                }
                if(!PesoDocumental && TipoRegime == E_TIPO_REGIME.Pier && TERMINAL == 'RIG') {
                    validacao++;
                    item.Erros['PesoDocumental'] = 'Obrigatório!';
                }
                if(!QtdContainer && TipoRegime == E_TIPO_REGIME.House) {
                    validacao++;
                    item.Erros['QtdContainer'] = 'Inválido!';
                }
                if(!Tipo) {
                    validacao++;
                    item.Erros['Tipo'] = 'Obrigatório!';
                }
                if(!TipoCntr && TipoRegime == E_TIPO_REGIME.House) {
                    validacao++;
                    item.Erros['TipoCntr'] = 'Obrigatório!';
                }
                if(!item.Status) {
                    validacao++;
                    item.Erros['Status'] = 'Obrigatório!';
                }

                return item;
            });
            
            return bl;
        });

        this.setValue(this.data, {...this.data.value, Erros, ['Bls']: blMapped } );
        
        if (validacao > 0) return { error: true, message: "É Necessário preencher todos os campos!" };
        if (validacaoDatas > 0) return { error: true, message: "Data saída maior que a entrada!" };

        filtros = Object.assign(filtros, { TipoRegime, ManualMecanizada, ParcialTotal, TipoDeclaracao });

        return await this.populateServicosBasicos(this.buildRequestBody(filtros, E_CONDICAO.Sim, Bls));
    }

    removeServico = (servico) => {
        const { Cntr: cr, NumBl: bl, Codigo: cod, CodigoPai: codPai, Qtd: q } = servico;

        const servicosFiltrados = this.servicos.filter(servico => {
            const { Codigo, CodigoPai, Cntr, NumBl } = servico;

            if (Cntr != cr || NumBl != bl) return servico;

            if (Codigo !== cod && CodigoPai !== cod && Codigo !== codPai) return servico;

            servico.Qtd -= q;

            return servico;
        }).filter(({ Qtd }) => Qtd > 0);

        this.servicos = servicosFiltrados;
    }
    
    removeServicoPorCodigo = (codigo) => {
        this.servicos = this.servicos.filter(s => s.Codigo != codigo);
    }

    addServicosAcessorios = (servicosSelecionados, Cntr, NumBl) => {
        const servicosIdentificados = servicosSelecionados.map(s => ({...s, Cntr, NumBl, Qtd: parseInt(s.Qtd) }));

        this.servicos = this.calcStore.concatServicos(this.servicos, servicosIdentificados);
    }

    resetarServicos = () => {
        this.servicos = [];
    }

    getItem = (blIndex, index) => {
        const { TipoRegime, ManualMecanizada, ParcialTotal, TipoDeclaracao, Bls } = toJS(this.data.value);

        const bl = Bls.at(blIndex);

        const item = bl.Items.at(index);

        return { 
                ...bl, 
                TipoRegime,
                ManualMecanizada,
                ParcialTotal,
                TipoDeclaracao,
                Cntr: item.Cntr, 
                Items: [ item ]
            };
    }

    getAllItems = () => {
        let result = [];
        toJS(this.data.value.Bls).forEach(({ Items }, blIndex) => {
            Items.forEach((_, index) => {
                result.push(this.getItem(blIndex, index));
            });
        });

        return result;
    }

    getFullFilterObject = (filtros) => {
        const { TipoRegime, ManualMecanizada, ParcialTotal, TipoDeclaracao } = toJS(this.data.value);

        return Object.assign(filtros, { TipoRegime, ManualMecanizada, ParcialTotal, TipoDeclaracao });
    }

    getFilterForServicosAcessorios = (f, cntr = null) => {
        const filtros = this.getFullFilterObject(f);

        let blArr = toJS(this.data.value.Bls);

        if (cntr != null) blArr = [ cntr ];  

        return this.buildRequestBody(filtros, E_CONDICAO.Nao, blArr);
    }

    getServicosIncluidosPorCntr = (cntr) => {
        if (!cntr) return [];

        const { Cntr, NumBl } = cntr;

        return this.servicos.filter(servico => Cntr == servico.Cntr && NumBl == servico.NumBl);
    }

    getServicosIncluidosPorIndex = (blIndex, index = 0) => {
        return this.getServicosIncluidosPorCntr(this.getItem(blIndex, index));
    }

    buildRequestBody = (f, ServicoBasico, Bls = []) => {
        const filtros = this.getFullFilterObject(f);

        let Processos = [];
        let Itens = [];

        const { DataEntrada, DataSaida } = toJS(this.data.value);

        if (Array.from(Bls).length > 0) {
            Processos = Bls.map(({ NumBl, Items, ValorCif }) => ({
                NumBl,
                DataEntrada,
                DataSaida,
                QtdCntr20: Items.reduce((result, { Tipo, QtdContainer }) => result + (Tipo && Tipo.value == E_TIPO.Cntr20 ? QtdContainer : 0), 0), 
                QtdCntr40: Items.reduce((result, { Tipo, QtdContainer }) => result + (Tipo && Tipo.value == E_TIPO.Cntr40 ? QtdContainer : 0), 0),
                Especial: Items.find(i => i.Especial) ? E_CONDICAO.Sim : E_CONDICAO.Nao,
                ValorCif: ValorCif ? parseFloat(ValorCif.replace(/[^,\d]+/g, '').replace(/,/g, '.')) : null,
            }));

            Itens = Bls.reduce((result, bl) => {
                return result.concat(bl.Items.map((_, index) => {
                    return this.buildItemRequestBody(filtros, ServicoBasico, bl, index)
                }));
            }, []);
        }
        else {
            Itens = [ this.buildItemRequestBody(filtros, ServicoBasico) ];
        }

        return {
            Processos,
            Itens
        }
    }

    buildItemRequestBody = (f, ServicoBasico, bl, itemIndex = 0) => {
        let requestBody = {
            Basico: ServicoBasico,
            TipoClienteId: f.tipoCliente,
            ModalidadeId: f.modalidade,
            SentidoOperacaoId: f.sentidoOperacao,
            OrigemCargaId: f.origemCarga,
            TipoRegimeId: f.TipoRegime,
            ManualMecanizadaId: f.ManualMecanizada,
            ParcialTotalId: f.ParcialTotal,
            TipoDeclaracaoId: f.TipoDeclaracao,
        };
        
        if (!bl) return requestBody;
        
        const { NumBl, Items, ValorCif } = bl;
        
        const { Cntr, QtdContainer, Tipo, Status, TipoCntr, Especial, Imo, Vistoria, Refrigerada, PesoDocumental, MetragemDocumental, } = Items.at(itemIndex);
        
        requestBody = Object.assign(requestBody, 
        {
            NumBl,
            Cntr,
            Qtd: QtdContainer,
            QtdDue: null,
            TipoId: Tipo.value,
            StatusId: Status.value,
            TipoCntrId: TipoCntr ? TipoCntr.value : null,
            Passagem: null,
            PesoDocumental, 
            MetragemDocumental,
            Especial: Especial ? 'V' : 'F',
            Imo: Imo ? 'V' : 'F',
            Vistoria: Vistoria ? 'V' : 'F',
            Refrigerada: Refrigerada ? 'V' : 'F',
        });

        return requestBody;
    }
    
    /**
     * Request to API the services based on filter and set servicos
     */
    populateServicosBasicos = async (requestBody) => {
        this.loadingServicos = true;

        try {            
            const { status, data } = await ServicosService.buscarServicos(requestBody);

            if (status == 200) {
                this.servicos = this.calcStore.ordenaServicos(data);

                var result = ({
                    status,
                    title: "Sucesso!",
                    message: "Busca realizada com sucesso.",
                    error: false
                });
            }
            else {
                var result = ({
                    status,
                    title: "Erro!",
                    message: data.Message || "Ocorreu um erro!",
                    error: true
                });
            }

            return result;

        } catch (error) {
            console.log("Error -> : ", error);

            return ({
                status: 500,
                title: "Erro!",
                message: error || "Ocorreu um erro na busca.",
                error: true
            });
        
        } finally {
            this.loadingServicos = false;
        }
    }

    calcularSimulacao = async ({ ehNacional }) => {        
        try {
            const convertLabels = (data, dadosLabel) => {
                const labels = [];

                Object.keys(dadosLabel).forEach(label => {
                    const chave = dadosLabel[label];
                    let value = data[label];

                    if (!value) return;

                    if (['QtdIsoCntr','QtdStatus','QtdTipoCntr'].includes(label)) {
                        value.split(',').map(obj => {
                            const array = obj.split(':');
                            labels.push( [array[0].trim() , array[1].trim() ]);
                        });
                    } else {
                        if (['DataEntrada','DataSaida'].includes(label)) 
                            value = moment(value).format("DD/MM/YYYY");
                        
                        if (['DtCriacao'].includes(label)) 
                            value = moment(value).format("DD/MM/YYYY HH:mm");

                        labels.push([ chave, value ]);
                    }
                });
                
                return labels;
            }
            
            const { DataEntrada, DataSaida, Bls } = toJS(this.data.value);

            const newSimulation = {
                DataEntrada,
                DataSaida,
                EhNacional: ehNacional,
                Servicos: []
            };

            newSimulation.Servicos = toJS(this.servicos).map(({ NumBl, Cntr, Codigo, ClassificacaoId, Qtd, QtdCntr20, QtdCntr40, ValorCif, Especial, Imo, Oog, Reefer, Vistoria, PesoDocumental, MetragemDocumental, }) => {
                return ({
                    NumBl, Cntr, Codigo, ClassificacaoId, Qtd, QtdCntr20, QtdCntr40, ValorCif, 
                    Especial, 
                    Imo: TERMINAL === "RIG" ? Especial : Imo,
                    Oog, Reefer, Vistoria, PesoDocumental, MetragemDocumental,
                })
            });

            console.log('### newSimulation: ', newSimulation);

            const { status, data } = await ServicosService.gerarSimulacao(newSimulation);

            const { data: dadosTerminal } = await ServicosService.buscarDadosTerminal();

            const dadosSimulacao = this.addAditionalProps(data, toJS(this.data.value));

            if (status == 200) {
                const dadosLabel = convertLabels(dadosSimulacao, dadosLabelsImp);

                let dadosProcessos = [];

                if (!this.temArmador) dadosProcessos = Bls.map(bl => {
                    const QtdTipoCntr = this.convertKeyValueToString(bl.Items, 'TipoCntr', 'label');
                    const QtdIsoCntr = this.convertKeyValueToString(bl.Items, 'Tipo', 'label', 'Container-');
                    const QtdEspecial = convertKeyValueToNumber(bl.Items, 'QtdContainer', 'Especial');
                    const QtdVistoria = convertKeyValueToNumber(bl.Items, 'QtdContainer', 'Vistoria');
                    const SomaTonelagem = convertKeyValueToNumber(bl.Items, 'PesoDocumental');
                    const SomaCubagem = convertKeyValueToNumber(bl.Items, 'MetragemDocumental');

                    return ({ dadosLabel: convertLabels({...bl, QtdTipoCntr, QtdIsoCntr, QtdEspecial, QtdVistoria, SomaTonelagem, SomaCubagem }, dadosLabelsBlImp) })
                });

                const url = TERMINAL === "RIG" ? cabecalhoRIG : cabecalhoSSA;

                const dadosModalidade = {
                    ...data, 
                    loading: false, 
                    AvisoImportante, 
                    Titulo: `Simulação ${E_TITULO_TELA.Importacao}`, 
                    dadosLabel,
                    dadosProcessos,
                    pdfHeaderImage: await getBase64ImageFromURL(url),
                    dadosTerminal,
                };

                var result = ({
                    status,
                    title: "Sucesso!",
                    message: "Cálculo realizado com sucesso.",
                    dadosModalidade,
                });
            }
            else {
                var result = ({
                    status,
                    title: "Erro!",
                    message: data.Message || "Ocorreu um erro!",
                });
            }

            return result;

        } catch (error) {
            console.log("Error -> : ", error);

            return ({
                status: 500,
                title: "Erro!",
                message: error || "Ocorreu um erro na simulação.",
            });
        }
    }

    convertKeyValueToString = (list, key, subKey = '', descricao = '') => {
        const arrayReduce = list.reduce((acc, obj) => {
            if (!Object.hasOwnProperty.call(obj, key)) return acc;
            if (!obj[key] || (subKey && !Object.hasOwnProperty.call(obj[key], subKey))) return acc;

            const keyDesc = descricao + (subKey ? obj[key][subKey] : obj[key]);
    
            acc[keyDesc] = acc[keyDesc] ? acc[keyDesc] + obj['QtdContainer'] : obj['QtdContainer'];
            
            return acc
        }, {});

        const objectKeys = Object.keys(arrayReduce);

        if (objectKeys.length == 0) return '';
    
        return objectKeys.map(key => `${key}: ${arrayReduce[key]}`).join(', ');
    }

    addAditionalProps = (data, { TipoRegime: TipoRegimeId, ManualMecanizada: ManualMecanizadaId, ParcialTotal: ParcialTotalId, TipoDeclaracao: TipoDeclaracaoId, Bls }) => {
        const TipoRegime = this.opcoesTipoRegimeImp.value.find(r => r.value == TipoRegimeId);
        if (TipoRegime) Object.assign(data, { TipoRegime: TipoRegime.label });

        const ManualMecanizada = this.opcoesManualMecanizadaImp.value.find(m => m.value == ManualMecanizadaId);
        if (ManualMecanizada) Object.assign(data, { ManualMecanizada: ManualMecanizada.label });

        const TipoDeclaracao = this.opcoesTipoDeclaracaoImp.value.find(r => r.value == TipoDeclaracaoId);
        if (TipoDeclaracao) Object.assign(data, { TipoDeclaracao: TipoDeclaracao.label });

        const ParcialTotal = this.opcoesParcialTotalImp.value.find(r => r.value == ParcialTotalId);
        if (ParcialTotal) Object.assign(data, { ParcialTotal: ParcialTotal.label });

        if (this.temArmador) {
            const Items = Bls.reduce((result, bl) => result.concat(bl.Items), []);

            const QtdIsoCntr = this.convertKeyValueToString(Items, 'Tipo', 'label', 'Container-');
            const QtdStatus = this.convertKeyValueToString(Items, 'Status', 'label', 'Status-');
            const QtdTipoCntr = this.convertKeyValueToString(Items, 'TipoCntr', 'label');

            const QtdEspecial = convertKeyValueToNumber(Items, 'QtdContainer', 'Especial');
            const QtdImo = convertKeyValueToNumber(Items, 'QtdContainer', 'Imo');
            const QtdCntr = convertKeyValueToNumber(Items, 'QtdContainer');

            Object.assign(data, { QtdIsoCntr, QtdStatus, QtdTipoCntr, QtdEspecial, QtdImo, QtdCntr });
        }

        return data;
    }
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/stores/SimulacaoServicosImpStore.js